/* eslint-disable no-multi-assign */
/* eslint-disable prettier/prettier */

/**
 * This file is auto-generated by the build/release process.
 * DO NOT MODIFY.
 */
const releaseName = 'zmyle-giftcards-ui:20260430150213:checkout-layout-v2:7bee283a3ad4c97ada18baaa00129a22efd71289';
const dirname = __dirname;

exports = module.exports = (() => {
  const data = releaseName.split(':');
  if (data.length !== 4) {
    throw Error(
      `No proper release info generated during build phase: '${releaseName}'`,
    );
  }
  return {
    name: String(data[0]),
    gitBranch: String(data[2]),
    gitCommit: String(data[3]),
    releasedAt: `${data[1]} +0000`,
    release: releaseName,
    __projectRootDirname: dirname,
  };
})();
